import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Col, Row, Modal } from '_zari/core'

import ListaDePaisesConstant from 'constants/listaDePaises'

import { ValidationSchema } from '../_shared/validation'
import DireccionFormGroup from '../_shared/formGroups/direccion'
import IdPaisFormGroup from '../_shared/formGroups/idPais'
import IdDepartamentoFormGroup from '../_shared/formGroups/idDepartamento'
import IdProvinciaFormGroup from '../_shared/formGroups/idProvincia'
import IdDistritoFormGroup from '../_shared/formGroups/idDistrito'

const NuevaDireccion = ({ handleClose, show, agregarDireccion }) => {
  const formInitialValues = React.useMemo(
    () => ({
      direccion: '',
      _idPais: '',
      _idDepartamento: '',
      _idProvincia: '',
      _idDistrito: ''
    }),
    []
  )

  const submitHandler = async data => {
    agregarDireccion(data)
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>NUEVA DIRECCION</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={formInitialValues}
        onSubmit={submitHandler}
        validationSchema={ValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, handleChange, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <IdPaisFormGroup
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                    iError={errors._idPais}
                    iTouched={touched._idPais}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              {values._idPais === ListaDePaisesConstant.PERU.ISO2 ? (
                <>
                  <Row>
                    <Col md={12}>
                      <IdDepartamentoFormGroup
                        values={values}
                        setValues={setValues}
                        handleChange={handleChange}
                        iError={errors._idDepartamento}
                        iTouched={touched._idDepartamento}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <IdProvinciaFormGroup
                        values={values}
                        setValues={setValues}
                        handleChange={handleChange}
                        idDepartamento={values._idDepartamento}
                        iError={errors._idProvincia}
                        iTouched={touched._idProvincia}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <IdDistritoFormGroup
                        values={values}
                        idProvincia={values._idProvincia}
                        iError={errors._idDistrito}
                        iTouched={touched._idDistrito}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row>
                </>
              ) : null}
              <Row>
                <Col md={12}>
                  <DireccionFormGroup
                    iError={errors.direccion}
                    iTouched={touched.direccion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevaDireccion
